var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 76.1,
    y: 86.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -58.9363 88.5551)",
    width: 2.7,
    height: 58.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.3,
    cy: 16.7,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.2,
    cy: 34.7,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.3,
    cy: 52.7,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.3,
    cy: 70.7,
    r: 9
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,36.1 0,39.9 32.7,72.6 34.7,70.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.2,85.3h-19L2.9,0H0v0.9l86.3,86.3l0.8,0.8h1.1H106c4.7,4.9,8.3,10.4,10.8,16.6c2.6,6.3,3.9,13,3.9,19.8 c0,1.1,0,2.3-0.1,3.4c-0.2,3.9-3.5,6-6.4,6c-1.2,0-2.8-0.3-4.4-1.9L0,22.3v3.8l107.9,107.8c1.8,1.8,4.1,2.6,6.3,2.6 c4.4,0,8.7-3.3,9.1-8.5c0.1-1.2,0.1-2.4,0.1-3.6c0-7.1-1.4-14.2-4.1-20.9C116.7,97,112.6,90.7,107.2,85.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBob);
export default __webpack_public_path__ + "static/media/bob.05e9f6f0d2ef8b25ae82c9c8b5f672fa.svg";
export { ForwardRef as ReactComponent };